import store from "@/store/index";

// responseType:"blob" 인스턴스(파일 다운로드 등)는 에러 응답 본문도 Blob으로 온다.
// 이후 모든 catch/에러 핸들러가 data.message·data.errors를 그대로 쓸 수 있도록 JSON으로 변환.
// JSON이 아니거나 비어있으면 원본을 그대로 둬서 상위에서 폴백 처리하게 한다.
async function normalizeBlobError(error) {
	const res = error && error.response;
	if (!res || typeof Blob === "undefined" || !(res.data instanceof Blob)) return;
	try {
		const text = await res.data.text();
		res.data = text ? JSON.parse(text) : null;
	} catch (e) {
		// 비 JSON/빈 응답 → 원본 유지
	}
}

export function setCommonInterceptors(instance) {
	instance.interceptors.request.use(
		(config) => {
			if (!config.skipLoading) {
				store.commit("uiStore/START_LOADING");
			}
			return config;
		},
		(error) => {
			store.commit("uiStore/END_LOADING");
			return Promise.reject(error);
		}
	);

	instance.interceptors.response.use(
		(response) => {
			if (!response.config.skipLoading) {
				store.commit("uiStore/END_LOADING");
			}
			return response;
		},
		async (error) => {
			if (!error.config?.skipLoading) {
				store.commit("uiStore/END_LOADING");
			}

			// blob 에러 본문을 JSON으로 정규화 (auth 인터셉터의 data.code 검사보다 먼저 실행됨)
			await normalizeBlobError(error);

			return Promise.reject(error);
		}
	);

	return instance;
}
